export const getVendorPaymentList = state => {
    return state.list
}

export const getVendorPaymentDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/vendorPayment/getters.js